module.exports = __webpack_public_path__ + "img/DE05577.69e0d8d8.png";